import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export class FromDraftJsonToDraftTrackingJsonMapper extends Mapper {
  constructor({config, trackingDataObjectMapper}) {
    super()
    this._trackingDataObjectMapper = trackingDataObjectMapper
  }

  map({draft = {}} = {}) {
    return this._trackingDataObjectMapper.map(draft)
  }
}
